import type { TOC } from '@ember/component/template-only'
import { ThStandard } from 'teacher-ui-client/components/th/standard'
import { t } from 'ember-intl'
import { formatValue } from 'teacher-ui-client/utils/format-value'
import type { SpellingProgressOverviewReportData } from 'teacher-ui-client/reporting/ui-scope/rex/dashboard/student/index/route'

interface Args {
  isLoading?: boolean
  overviewData: SpellingProgressOverviewReportData['overview']
}

interface Signature {
  Args: Args
  Element: Element
}
export const RexSpellingProgressOverview: TOC<Signature> = <template>
  <table class="border-oceany-blue-150 border-b text-center" ...attributes>
    <thead class="bg-oceany-blue-50">
      <tr class="divide-x divide-white">
        <ThStandard>
          {{t "components.reporting.tables.readingEggspress.dashboardStudent.headers.highestLessonCompleted"}}
        </ThStandard>
        <ThStandard class="bg-oceany-blue-100">
          {{t "components.reporting.tables.readingEggspress.dashboardStudent.headers.totalLessonsCompleted"}}
        </ThStandard>
        <ThStandard>
          {{t "components.reporting.tables.readingEggspress.dashboardStudent.headers.averageOverallScore"}}
        </ThStandard>
      </tr>
    </thead>
    <tbody class={{if @isLoading "opacity-50"}}>
      <tr>
        <td class="p-3">{{formatValue @overviewData.highest_lesson_completed}}</td>
        <td class="p-3">{{formatValue @overviewData.total_lessons_completed}}</td>
        <td class="p-3">{{formatValue @overviewData.average_overall_score append="%"}}</td>
      </tr>
    </tbody>
  </table>
</template>

export default RexSpellingProgressOverview
